<template>
  <div style="
  height: calc(100vh - 55px);
width: 100%;
    display: block;
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: normal;">
      <b-row style="height: 100%">
        <b-col md="3" style="height: 100%">
          <tree @open-add="$refs.create_augr.showDialog()" @configure="$refs.setting_dialog.showDialog()"
                @node-right-click="onNodeRightClick"
                filterPlaceholder="Suchen" filterBy="label" selectionMode="single" @node-select="onNodeSelect"
                @node-unselect="onNodeUnselect" :selectionKeys.sync="selectedKey" :expandedKeys.sync="expandedKeys" :filter="true"
                filterMode="lenient" :value="filteredNodes" style="height: 100%; overflow: auto; border: none; border-right: 1px solid #c2c2c2" :disabled="editMode"></tree>
        </b-col>
        <b-col style="height: 100%; overflow-y: scroll;">
          <b-row class="mt-3">
            <b-button variant="primary" pill class="mb-2 mr-2" @click="$refs.select_augr_dialog.showDialog()" :disabled="editMode">
              <add-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></add-icon>Stammauftrag
            </b-button>
            <b-button v-if="false" variant="success" pill class="mb-2" :disabled="editMode">
              <add-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></add-icon>Unterauftrag
            </b-button>
            <b-col class="flex-row-reverse" style="display: flex">
              <!--b-button v-if="!editMode" variant="primary" pill class="mb-2 ml-2 mr-2">
                Zurück
              </b-button-->
              <b-button v-if="editMode" variant="success" pill class="mb-2 ml-2 mr-2" @click="onSave">
                Speichern
              </b-button>
              <b-button v-if="editMode" variant="danger" pill class="mb-2 ml-2" @click="toggleEdit">
                Abbrechen
              </b-button>
              <b-button v-if="false && currentSelection && currentSelection.data.pos_nr && currentSelection.data.pos_nr > '0200' && !editMode" variant="success" pill class="mb-2 ml-2">
                <add-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></add-icon>Aufgabe
              </b-button>
              <b-button v-if="!editMode && auftrag" variant="success" pill class="mb-2 ml-2" @click="toggleEdit">
                <edit-icon fillColor="white" class="icon-1_5x custom-icon-size" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></edit-icon>Bearbeiten
              </b-button>
            </b-col>
          </b-row>
          <b-card v-if="auftrag"header-tag="header" style="margin-left: -15px; margin-right: 8px">
            <template #header>
              <b-row>
                <b-col md="6" sm="12"><b-row style="gap: 8px; padding-left: 8px; padding-right: 8px">
                  <span class="label-horizontal"><b>Auftragsgrp.</b></span>
                  <b-form-input class="fc-disabled" v-model="auftrag.augr" disabled style="flex-grow: 1;width: 1px;"></b-form-input>
                  <b-form-input class="fc-disabled" v-model="auftragAugrName" disabled style="flex-grow: 5;width: 1px;"></b-form-input>
                </b-row></b-col>
                <b-col md="6" sm="12"><b-row style="gap: 8px; padding-left: 8px; padding-right: 8px">
                  <span class="label-horizontal"><b>Stammauftrag:</b></span>
                  <b-form-input class="fc-disabled" v-model="auftrag.aufisn" disabled style="flex-grow: 1;width: 1px;"></b-form-input>
                  <span class="label-horizontal"><b>Unterauftrag:</b></span>
                  <b-form-input class="fc-disabled" v-model="auftrag.pos_nr" disabled style="flex-grow: 1;width: 1px;"></b-form-input>
                </b-row></b-col>
              </b-row>
            </template>
            <b-row>
              <b-col>
                <b-row class="mb-3">
                  <b-col><h4>Auftragsbeschreibung:</h4></b-col>
                </b-row>
                <b-row class="mb-2" v-if="auftrag.pos_nr !== '0000'">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Was:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.task" placeholder="Kurzbeschreibung"
                                  :disabled="!editMode"
                                  style="color: black"
                                  :state="errors.taskError"
                                  @focusin="errors.taskError = null"
                                  aria-describedby="task-feedback"></b-form-input>
                    <b-form-invalid-feedback id="task-feedback">
                      Darf nicht leer sein.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">{{auftrag.pos_nr !== '0000' ? "Wo:" : "Objekt:" }}</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.object" placeholder="Objektname"
                                  :disabled="!editMode"
                                  style="color: black"
                                  :state="errors.objectError"
                                  aria-describedby="object-feedback"
                                  @focusin="errors.objectError = null"
                    ></b-form-input>
                    <b-form-invalid-feedback id="object-feedback">
                      Darf nicht leer sein.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="auftrag.pos_nr > '0200'">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Beschreibung:</span></b-col>
                  <b-col>
                    <b-form-textarea
                        class="text-black"
                        rows="6"
                        max-rows="6"
                        wrap="hard"
                        style="min-height: 150px; color: black"
                        :disabled="!editMode"
                        v-model="auftrag.memo"
                    ></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="auftrag.pos_nr > '0200'">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Leistungsgruppe:</span></b-col>
                  <b-col>
                    <b-form-select :options="legrs" :plain="true"
                                   v-model="auftrag.legr"
                                   class="text-black"
                                   :disabled="!editMode"
                                   value-field="gischl"
                                   text-field="name"
                                   :state="errors.legrError"
                                   aria-describedby="legr-feedback"
                                   @focusin="errors.legrError = null"
                    ></b-form-select>
                    <b-form-invalid-feedback id="legr-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Adresse:</span></b-col>
                  <b-col>
                    <b-input-group >
                      <b-form-input v-model="address" placeholder="Str Hnr, Land-PLZ Ort" :disabled="!editMode" style="color: black"></b-form-input>
                      <b-input-group-append is-text v-if="editMode && auftrag.pos_nr === '0000' && auftrag.id"><svg style="transition: all .2s;" @click="goToGps" class="hover" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#5f6368"><path d="m574-129-214-75-186 72q-10 4-19.5 2.5T137-136q-8-5-12.5-13.5T120-169v-561q0-13 7.5-23t20.5-15l186-63q6-2 12.5-3t13.5-1q7 0 13.5 1t12.5 3l214 75 186-72q10-4 19.5-2.5T823-824q8 5 12.5 13.5T840-791v561q0 13-7.5 23T812-192l-186 63q-6 2-12.5 3t-13.5 1q-7 0-13.5-1t-12.5-3Zm-14-89v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"/></svg>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="auftrag.pos_nr > '0200'">
                  <b-col md="3"><span class="label-horizontal label-fc-height">AuftragsNr. Extern:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.beleg_ex" placeholder="Auftragsnr. Extern:" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Abrechnungs-Kenz.:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.nkr_kasse" placeholder="Abrechn-Kz.:" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-3">
                  <h4>{{ageber ? 'Auftraggeber' : 'abw. Rechn.-Empfänger'}}</h4>
                  <div class="hover" @click="isDebitor = false; $refs.address_dialog.showDialog()" v-if="editMode" style="margin-left: 0.5rem; cursor: pointer; transition: all 0.2s ease 0s; max-height: 30px; display: flex;"><svg data-v-072c5d72="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path xmlns="http://www.w3.org/2000/svg" d="M440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T520-640q0-33-23.5-56.5T440-720q-33 0-56.5 23.5T360-640q0 33 23.5 56.5T440-560ZM856-48 756-148q-21 12-45 20t-51 8q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 27-8 51t-20 45l100 100q11 11 11 28t-11 28q-11 11-28 11t-28-11ZM660-200q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-540-40v-31q0-34 17-63t47-44q42-22 93.5-38.5T383-438q17-2 29 10t12 29q0 17-12 29.5T383-355q-57 7-96 21t-66 28q-10 5-15.5 14.5T200-271v31h184q17 0 28.5 11.5T424-200q0 17-11.5 28.5T384-160H200q-33 0-56.5-23.5T120-240Zm320-400Zm-33 400Z"/></svg></div>                  <div style="flex-grow: 1"></div>
                  <b-button style="align-self: flex-start; margin-right: 12px" variant="primary" size="sm" @click="ageber = !ageber">
                    {{ageber ? 'abw. Rechn.-Empfänger' : 'Auftraggeber' }}
                  </b-button>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Anrede:</span></b-col>
                  <b-col md="3">
                    <b-form-select :options="anrede_select" id="anrede" :plain="true"
                                   v-model="auftrag.salutation"
                                   class="text-black"
                                   :disabled="!editMode"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Anrede:</span></b-col>
                  <b-col md="3">
                    <b-form-select :options="anrede_select" id="anrede" :plain="true"
                                   v-model="auftrag.re_anrede"
                                   class="text-black"
                                   :disabled="!editMode"
                    ></b-form-select>
                  </b-col>
                  <b-col md="2"><span class="label-horizontal label-fc-height">PK Nr:</span></b-col>
                  <b-col md="4">
                    <b-form-input v-model="auftrag.re_nr" placeholder="PK Nummer" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Name 1:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.name_1" placeholder="Name 1" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Name:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.re_vorname" placeholder="Name" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Name 2:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.name_2" placeholder="Name 2" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Zu Händen:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.re_name_1" placeholder="Zu Händen" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Straße Hnr:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.street" placeholder="Straße Hausnummer" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Straße Hnr:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.re_strh_nr" placeholder="Straße Hausnummer" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">PLZ   Ort:</span></b-col>
                  <b-col md="3">
                    <b-form-input v-model="auftrag.zip_code" placeholder="PLZ" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                  <b-col md="6">
                    <b-form-input v-model="auftrag.city" placeholder="Ort" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Land   PLZ   Ort:</span></b-col>
                  <b-col md="2">
                    <b-form-input v-model="auftrag.re_land" placeholder="Land" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <b-form-input v-model="auftrag.re_plz" placeholder="PLZ" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                  <b-col md="4">
                    <b-form-input v-model="auftrag.re_ort" placeholder="Ort" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2 mt-2" v-if="false && ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Fax:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.fax" placeholder="Faxnummer" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Email:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.email" placeholder="Email" :disabled="!editMode" style="color: black"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber && settings.useAnehmer">
                  <b-col md="3"><span class="label-horizontal label-fc-height">{{settings.anehmerName}}:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showAufnSelect"/>
                    <b-form-select :options="anehmer" :plain="true"
                                   v-model="auftrag.anehmer"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="name"
                                   text-field="name"
                                   :state="errors.anehmerError"
                                   aria-describedby="anehmer-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="anehmer-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showAufnSelect"/>

                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="ageber && settings.useKombi">
                  <b-col md="3"><span class="label-horizontal label-fc-height">{{settings.kombiName}}:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showCommuneSelect"/>
                    <b-form-select :options="commune_select" :plain="true"
                                   v-model="auftrag.kombi"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="name"
                                   text-field="name"
                                   :state="errors.kombiError"
                                   aria-describedby="komi-feedback"

                    ></b-form-select>
                    <b-form-invalid-feedback id="kombi-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showCommuneSelect"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-3 pt-2 mt-2" v-if="!settings.zwtKreislauf" style="border-top: 1px solid #d1d0d0">
              <b-col><h4>Konten Einnahmen/Ausgaben:</h4></b-col>
            </b-row>
            <b-row class="mb-3 pt-2 mt-2" v-if="settings.zwtKreislauf" style="border-top: 1px solid #d1d0d0">
              <b-col><h4>Konten eigen:</h4></b-col>
              <b-col><h4>Konten Auftraggeber:</h4></b-col>
            </b-row>
            <b-row v-if="!settings.zwtKreislauf && currentAugr.augr_type !== 'KOST'">
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Erlöskonto:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('E')"/>
                    <b-form-select :options="hhEin" :plain="true"
                                   v-model="auftrag.hh_ein"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="account"
                                   text-field="account"
                                   aria-describedby="hhEin-feedback"
                                   :state="errors.hhEinError"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhEin-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('E')"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Debitor:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('A')"/>
                    <b-form-select :options="hhAus" :plain="true"
                                   v-model="auftrag.hh_aus"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="account"
                                   text-field="account"
                                   :state="errors.hhAusError"
                                   aria-describedby="hhAus-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhAus-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('A')"/>
                    <!--b-form-input v-model="auftrag.hh_aus" placeholder="Konto Debitor" :disabled="!editMode" style="color: black"></b-form-input-->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="!settings.zwtKreislauf && currentAugr.augr_type === 'KOST'">
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Erlöskonto:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('E')"/>
                    <b-form-select :options="kosts" :plain="true"
                                   v-model="auftrag.hh_ein"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="name"
                                   text-field="name"
                                   aria-describedby="hhEinK-feedback"
                                   :state="errors.hhEinError"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhEinK-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('E')"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Debitor:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('A')"/>
                    <b-form-select :options="kosts" :plain="true"
                                   v-model="auftrag.hh_aus"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="name"
                                   text-field="name"
                                   :state="errors.hhAusError"
                                   aria-describedby="hhAusK-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhAusK-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('A')"/>
                    <!--b-form-input v-model="auftrag.hh_aus" placeholder="Konto Debitor" :disabled="!editMode" style="color: black"></b-form-input-->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="settings.zwtKreislauf">
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Erlös:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showKKontoSelect"/>
                    <b-form-select :options="k_konten" :plain="true"
                                   v-model="auftrag.hh_ein"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="konto"
                                   text-field="konto"
                                   :state="errors.hhEinError"
                                   aria-describedby="hhEinE-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhEinE-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showKKontoSelect"/>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Debitor:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="isDebitor = true; errors.hhAusError = null; $refs.address_dialog.showDialog()"/>
                    <b-form-select :options="addresses" :plain="true"
                                   v-model="auftrag.hh_aus"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="debitor"
                                   text-field="debitor"
                                   :state="errors.hhAusError"
                                   aria-describedby="hhAusE-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhAusE-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="isDebitor = true; errors.hhAusError = null; $refs.address_dialog.showDialog()"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Kreditor:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('E')"/>
                    <b-form-select :options="hhEin" :plain="true"
                                   v-model="auftrag.hh_fahr"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="account"
                                   text-field="account"
                                   :state="errors.hhFahrError"
                                   aria-describedby="hhFahr-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhFahr-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('E')"/>
                    <!--b-form-input v-model="auftrag.hh_aus" placeholder="Konto Debitor" :disabled="!editMode" style="color: black"></b-form-input-->
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="3"><span class="label-horizontal label-fc-height">Konto Ausgabe:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSelectHh('A')"/>
                    <b-form-select :options="hhAus" :plain="true"
                                   v-model="auftrag.hh_mat"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                                   value-field="account"
                                   text-field="account"
                                   :state="errors.hhMatError"
                                   aria-describedby="hhMat-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="hhMat-feedback">
                      Muss gesetzt sein.
                    </b-form-invalid-feedback>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSelectHh('A')"/>
                    <!--b-form-input v-model="auftrag.hh_aus" placeholder="Konto Debitor" :disabled="!editMode" style="color: black"></b-form-input-->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-3 pt-2 mt-2" style="border-top: 1px solid #d1d0d0">
              <b-col><h4>Informationen:</h4></b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="4"><span class="label-horizontal label-fc-height">Sachbearbeiter:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showSachSelect"/>
                    <b-form-select :options="sachs" :plain="true"
                                   v-model="auftrag.clerk"
                                   disabled
                                   value-field="name"
                                   text-field="name"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                    ></b-form-select>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showSachSelect"/>

                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="4"><span class="label-horizontal label-fc-height">Telefon:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.clerk_tel" placeholder="Telefonnummer" :disabled="!editMode" style="color: black" type="tel"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="4"><span class="label-horizontal label-fc-height">MWST:</span></b-col>
                  <b-col>
                    <b-form-select :options="mwst_select" :plain="true"
                                   v-model="auftrag.mwst_percentage"
                                   class="text-black"
                                   :disabled="!editMode"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col md="4"><span class="label-horizontal label-fc-height">Abrechnungsart:</span></b-col>
                  <b-col>
                    <input style="padding: 0; border: none; width: 0px;height: 0px;position: absolute;" :disabled="!editMode" @focus.prevent="showBillingType"/>
                    <b-form-select :options="billing_typ_selects" :plain="true"
                                   v-model="auftrag.art_auf"
                                   :class="{ 'sel-enabled': editMode, 'text-black': true }"
                                   disabled
                    ></b-form-select>
                    <div style="position: absolute; left: 15px; right:15px; top: 0; bottom:0;"  @click="showBillingType"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="mb-2">
                  <b-col md="4"><span class="label-horizontal label-fc-height">Abrechnungstyp:</span></b-col>
                  <b-col>
                    <b-form-select :options="aar_select" :plain="true"
                                   v-model="auftrag.aar"
                                   class="text-black"
                                   :disabled="!editMode"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-if="auftrag.aar !== 'A' && auftrag.aar !== ''">
                  <b-col md="4"><span class="label-horizontal label-fc-height">Budget:</span></b-col>
                  <b-col>
                    <b-form-input v-model="auftrag.budget" placeholder="Budget" :disabled="!editMode" style="color: black;" type="number"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    <create-augr-dialog ref="create_augr" :augr-types-available="augrTypesAvailable" :augr-names="augrNames" @create-augr="onCreateAugr"/>
    <settings-dialog ref="setting_dialog" :settings="settings" @save-settings="onSaveSettings"/>
    <billing-typ-dialog ref="billing_type_dialog" @set-billing-type="setBillingType"/>
    <address-dialog ref="address_dialog" :is-debitor="isDebitor" :is-a-geber="ageber" :addresses="addresses" @set-address="setAddress" @add-address="$refs.create_address_dialog.showModal()"/>
    <create-address-dialog ref="create_address_dialog" :is-a-geber="ageber" @create-address="createAddress"/>
    <select-hh-dialog ref="select_hh_dialog" :hh-type="currentHhType" :hhs="currentHhs" @add-hh="$refs.create_hh_dialog.showModal(currentHhType)" @set-hh="setHh"/>
    <create-hh-dialog ref="create_hh_dialog" @create-hh="createHh" :hh-mask="settings.maskKonto" :hh-desc="settings.descKonto"/>
    <select-aufn-dialog ref="select_aufn_dialog" :aufn-name="settings.anehmerName" :aufns="anehmer" @add-aufn="$refs.create_aufn_dialog.showModal()" @set-aufn="setAufn"/>
    <create-aufn-dialog ref="create_aufn_dialog" :aufn-name="settings.anehmerName" @create-aufn="createAufn"/>
    <select-sach-dialog ref="select_sach_dialog" :sachs="sachs" @add-sach="$refs.create_sach_dialog.showModal()" @set-sach="setSach"/>
    <create-sach-dialog ref="create_sach_dialog" @create-sach="createSach"/>
    <select-commune-dialog ref="select_commune_dialog" :commune-name="settings.kombiName" :communes="commune_select" @add-commune="$refs.create_commune_dialog.showModal()" @set-commune="setCommune"/>
    <create-commune-dialog ref="create_commune_dialog" :commune-name="settings.kombiName" @create-commune="createCommune"/>

    <select-k-konto-dialog ref="select_k_konto_dialog" :k_konten="k_konten" @add-k-konto="$refs.create_k_konto_dialog.showModal()" @set-k-konto="setKKonto"/>
    <create-k-konto-dialog ref="create_k_konto_dialog" @create-k-konto="createKKonto"/>
    <check-hh-date-dialog ref="check_hh_date_dialog" @hh-change-date="saveAuftrag"/>
    <select-augr-dialog ref="select_augr_dialog" :augrs="augrs" :selected-augr="selectedAugr" @select-augr="createNew"/>

    <select-kost-dialog ref="select_kost_dialog" :kosts="kosts" @add-kost="$refs.create_kost_dialog.showModal()" @set-kost="setKost"/>
    <create-kost-dialog ref="create_kost_dialog" @create-kost="createKost"/>

    <accept-task-dialog ref="accept_dialog" :bauhof-structure="bauhofStructure" :auftrag="auftrag"
                        :close-automatic-presets="av_close_defaults"
                        @select-planning="(users) => {$refs.select_plannings.showDialog(users)}"
                        @change-planning="(currentPlanning) => {$refs.change_todo.showDialog(currentPlanning)}"
                        :create-short="true"
                        @accept-task="saveEinzel"
    ></accept-task-dialog>
    <select-planning-dialog ref="select_plannings" @planning-selected="(plannings) => {$refs.accept_dialog.onNewPlanning(plannings)}"></select-planning-dialog>
    <change-todo-dialog ref="change_todo" @change-todo="(todo) => {$refs.accept_dialog.onChangeTodo(todo)}"></change-todo-dialog>
    <change-augr-name-dialog @change-augr-name="changeAugrName" ref="change_augr_name" :augr-name="currentRightClickNode ? currentRightClickNode.label : ''"/>
    <b-modal title="Auftragsgruppe löschen" size="sm" v-model="deleteAugrModal" @ok="deleteAugr" ok-variant="danger"
             ok-title="Löschen" cancel-title="Abbruch" centered>
      Möchten sie diese Auftragsgruppe wirklich löschen?
      Das kann nicht rückgängig gemacht werden.
    </b-modal>
    <b-modal title="Stammauftrag löschen" size="sm" v-model="deleteStammModal" @ok="deleteStamm" ok-variant="danger"
             ok-title="Löschen" cancel-title="Abbruch" centered>
      Möchten sie diesen Stammauftrag wirklich löschen?
      Das kann nicht rückgängig gemacht werden.
    </b-modal>
    <b-modal title="Stammauftrag sperren" size="sm" v-model="closeStammModal" @ok="closeStamm" ok-variant="danger"
             ok-title="Sperren" cancel-title="Abbruch" centered>
      Möchten sie diesen Stammauftrag wirklich sperren?
      Das kann nicht rückgängig gemacht werden.
    </b-modal>

    <select-augr-dialog ref="select_augr_dialog_2" :augrs="augrs" :selected-augr="selectedAugr" @select-augr="switchAugr"/>

    <vue-context ref="menu">
      <li
          v-for="opt in currentOptions"
          :key="opt"
      >
        <a href="#" @click.prevent="onOptionClicked(opt)">{{opt}}</a>
      </li>
    </vue-context>
  </div>
</template>


<script>
import Tree from '../custom/Tree.vue';
import CreateAugrDialog from './CreateAugrDialog.vue';
import AddressDialog from './AddressDialog.vue';
import SelectAufnDialog from './SelectAufnDialog.vue';
import SelectKostDialog from './SelectKostDialog.vue';
import SelectSachDialog from './SelectSachDialog.vue';
import SelectCommuneDialog from './SelectCommuneDialog.vue';
import SelectKKontoDialog from './SelectKKontoDialog.vue';
import CreateAddressDialog from './CreateAddressDialog.vue';
import CreateHhDialog from './CreateHhDialog.vue';
import CreateAufnDialog from './CreateAufnDialog.vue';
import CreateSachDialog from './CreateSachDialog.vue';
import CreateCommuneDialog from './CreateCommuneDialog.vue';
import CreateKKontoDialog from './CreateKKontoDialog.vue';
import CreateKostDialog from './CreateKostDialog.vue';
import CheckHhDateDialog from './CheckHhDateDialog.vue';
import SettingsDialog from './SettingsDialog.vue';
import BillingTypDialog from './BillingTypDialog.vue';
import SelectHhDialog from './SelectHhDialog.vue';
import SelectAugrDialog from './SelectAugrDialog.vue';
import ChangeAugrNameDialog from './ChangeAugrNameDialog.vue';
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import EditIcon from 'vue-material-design-icons/Pencil.vue';
import SwitchIcon from 'vue-material-design-icons/Sync.vue';
import {
  decryptAddress,
  decryptSach,
  decryptTask,
  encryptAddress,
  encryptSach,
  encryptTask,
  encryptTodos
} from "@/shared/crypto";
import AcceptTaskDialog from "@/views/aufgaben_verwaltung/AcceptTaskDialog.vue";
import SelectPlanningDialog from "@/views/aufgaben_verwaltung/SelectPlanningDialog.vue";
import ChangeTodoDialog from "@/views/aufgaben_verwaltung/ChangeTodoDialog.vue";
import VueContext from 'vue-context';


export default {
  name: "Stammauftraege",
  components: {
    ChangeTodoDialog,
    SelectPlanningDialog,
    AcceptTaskDialog,
    SelectAufnDialog,
    SettingsDialog,
    'tree': Tree,
    CreateAugrDialog, AddIcon,
    EditIcon, SwitchIcon, BillingTypDialog,
  AddressDialog, CreateAddressDialog, SelectHhDialog,
    CreateHhDialog, CreateAufnDialog,
    SelectSachDialog, CreateSachDialog, SelectCommuneDialog,
    CreateCommuneDialog, SelectKKontoDialog,
    CreateKKontoDialog, CheckHhDateDialog, SelectAugrDialog,
    SelectKostDialog, CreateKostDialog, VueContext,
    ChangeAugrNameDialog},
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL+'/auftragsbuch/data/stamm'
    ).then(this.responseOkGet, this.responseError)
  },
  data() {
    return {
      selectedKey: {},
      expandedKeys: {},
      loader: undefined,
      augrTypesAvailable: {
        fahr: true,
        play: false,
        street: false,
      },
      settings: {
        showClosed: false,
        showLegr: true,
        zwtKreislauf: false,
        useAnehmer: false,
        anehmerName: 'Ortsteil',
        useKombi: false,
        kombiName: 'Kommune',
        maskKonto: '',
        descKonto: '',
        mwsts: [],
      },
      nodes:  [
        ],
      currentSelection: null,
      editMode: false,
      auftrag: null,
      auftragAugrName: '',
      legrs: [],
      address: '',
      gpsAddress: null,
      anrede_select: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],
      billing_typ_selects: [
        {value: 'S', text: 'Einmalrechnung'},
        {value: 'T', text: 'Sammelrechnung über Stammauftrag'},
        {value: 'D', text: 'Dauereinzelauftrag'},
        {value: 'F', text: 'Fremdauftrag mit Unteraufträgen'},
        {value: 'N', text: 'Nicht abrechnen/Intern'},
      ],
      //mwst_select: [{value: 0, text: '---'}, {value: 7, text: '7%'}, {value: 19, text: '19%'}],
      aar_select: [{value: 'A', text: 'nach Aufwand'}, {value: 'P', text: 'Pauschale'}, {value: 'M', text: 'monatl. Pauschal'}, {value: 'Q', text: 'quart. Pauschale'}],
      commune_select: [],
      anehmer: [],
      zwtKreislauf: false,
      eigenAufteilen: false,
      hhs: [],
      hhEin: [],
      hhAus: [],
      addresses: [],
      ageber: true,
      sachs: [],
      k_konten: [],
      currentHhType: '',
      isDebitor: false,
      augrs: [],
      selectedAugr: '',
      errors: {
        taskError: null,
        objectError: null,
        legrError: null,
        anehmerError: null,
        kombiError: null,
        hhEinError: null,
        hhAusError: null,
        hhFahrError: null,
        hhMatError: null,
      },
      kosts: [],
      currentAugr: {
        name: '',
        augr_type: '',
      },
      av_close_defaults: null,
      bauhofStructure: [],
      currentRightClickNode: null,
      deleteAugrModal: false,
      deleteStammModal: false,
      closeStammModal: false,
    }
  },
  watch: {
    editMode(n, o) {
      if (this.currentSelection && this.auftrag && this.auftrag.id) {
        this.$router.replace({
          path: this.$route.path,
          query: {key: this.currentSelection.key, edit: n ? 'true' : 'false'}
        })
      } else {
        console.log(this.$route)
        this.$router.replace({
          path: this.$route.path,
        })
      }
    }
  },
  methods: {
    onNodeRightClick(event) {
      let node = event.node;
      if (node && node.data) {
        event.originalEvent.preventDefault();
        if (node.data.augr_type !== undefined) {
          // we are at augr level
          this.currentRightClickNode = node;
          this.$refs.menu.open(event.originalEvent);
        } else if (node.data.aufisn && node.data.pos_nr === '0000') {
          this.currentRightClickNode = node;
          this.$refs.menu.open(event.originalEvent);
        } else {
          this.currentRightClickNode = null;
        }
      } else {
        this.currentRightClickNode = null;
      }
    },
    changeAugrName(name) {
      this.showLoader();
      if (this.currentAugr && this.currentAugr.name === this.currentRightClickNode.data.name) {
        this.currentAugr.name = name;
      }
      if (this.auftragAugrName === this.currentRightClickNode.data.name) {
        this.auftragAugrName = name;
      }
      for (let i = 0; i < this.augrs.length; i++) {
        if (this.augrs[i].gischl === this.currentRightClickNode.data.gischl) {
          this.augrs[i].name = name;
          break;
        }
      }
      for (let i = 0; i < this.nodes.length; i++) {
        if (this.nodes[i].key === this.currentRightClickNode.key) {
          this.nodes[i].label = name;
          this.nodes[i].data.name = name;
          break;
        }
      }
      this.nodes.sort((a, b) => {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      })
      this.augrs.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      })
      this.$http.patch(
          Server_URL+'/auftragsbuch/data/augr', {
            id: this.currentRightClickNode.data.id,
            gischl: this.currentRightClickNode.data.gischl,
            name: name,
            augr_type: this.currentRightClickNode.data.augr_type,
          }
      ).then(this.responseOkTrap, this.responseError)
    },
    deleteAugr() {
      if (this.currentAugr && this.currentAugr.id === this.currentRightClickNode.key) {
        this.currentAugr = null;
      }
      for (let i = 0; i < this.augrs.length; i++) {
        if (this.augrs[i].gischl === this.currentRightClickNode.data.gischl) {
          this.augrs.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.nodes.length; i++) {
        if (this.nodes[i].key === this.currentRightClickNode.key) {
          this.nodes.splice(i, 1);
          break;
        }
      }

      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/augr/delete', {
            id: this.currentRightClickNode.data.id,
            gischl: this.currentRightClickNode.data.gischl,
          }
      ).then(this.responseOkTrap, this.responseError)
    },
    deleteStamm() {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/stamm/delete', {
            id: this.currentRightClickNode.data.id,
            augr: this.currentRightClickNode.data.augr,
            aufisn: this.currentRightClickNode.data.aufisn,
          }
      ).then(r => {
        this.currentSelection = null;
        this.auftrag = null;
        this.editMode = false;
        this.$http.get(
            Server_URL+'/auftragsbuch/data/stamm'
        ).then(this.responseOkGet, this.responseError)
      }, this.responseError)
    },
    closeStamm() {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/stamm/close', {
            id: this.currentRightClickNode.data.id,
            augr: this.currentRightClickNode.data.augr,
            aufisn: this.currentRightClickNode.data.aufisn,
          }
      ).then(r => {
        this.currentSelection = null;
        this.auftrag = null;
        this.editMode = false;
        this.$http.get(
            Server_URL+'/auftragsbuch/data/stamm'
        ).then(this.responseOkGet, this.responseError)
      }, this.responseError)
    },
    switchAugr(augr) {
      let augrName =  augr.name;
      let augrGischl = augr.gischl;
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/stamm/move', {
            id: this.currentRightClickNode.data.id,
            old_augr_gischl: this.currentRightClickNode.data.augr,
            aufisn: this.currentRightClickNode.data.aufisn,
            new_augr_gischl: augrGischl,
            new_augr_name: augrName,
          }
      ).then(r => {
        this.currentSelection = null;
        this.auftrag = null;
        this.editMode = false;
        this.$http.get(
            Server_URL+'/auftragsbuch/data/stamm'
        ).then(this.responseOkGet, this.responseError)
      }, this.responseError)
    },
    onOptionClicked(option) {
      if (this.currentRightClickNode.data.augr_type !== undefined) {
        if (option === "Umbenennen") {
          this.$refs.change_augr_name.showModal();
        } else if (option === "Löschen") {
          this.deleteAugrModal = true;
        }
      } else if (this.currentRightClickNode.data.aufisn && this.currentRightClickNode.data.pos_nr === '0000') {
        if (option === "Auftragsgruppe wechseln") {
          this.$refs.select_augr_dialog_2.showDialog();
        } else if (option === "Löschen") {
          this.deleteStammModal = true;
        } else if (option === "Sperren") {
          this.closeStammModal = true;
        }
      }
    },
    createNew(augr) {
      this.auftragAugrName = augr.name;
      this.currentAugr = augr;
      this.address = '';
      this.auftrag = {
        augr: augr.gischl,
        aufisn: 'wird vergeben',
        pos_nr: augr.billing_type === 'EX@EI@DE' ? '9999' : '0000',
        object: '',
        task: '',
        task_type_1: augr.billing_type.startsWith('IN') ? 'I' : 'E',
        task_type_2: augr.billing_type.includes('@DA@') ? 'D' : 'E',
        clerk_tel: '',
        clerk: '',
        legr: 'EX@EI@DE' ? '' : '000000',
        legr_text: '',
        leist: '',
        leist_text: '',
        memo: '',
        address_id: '',
        salutation: '',
        name_1: '',
        name_2: '',
        street: '',
        zip_code: '',
        city: '',
        aar: 'A',
        zaar_text: 'nach Aufwand',
        hh_ein: '',
        hh_ein_text: '',
        hh_aus: '',
        hh_aus_text: '',
        hh_fahr: '',
        hh_fahr_text: '',
        hh_mat: '',
        hh_mat_text: '',
        art_auf: augr.billing_type === 'EX@EI@DE' ? 'S' : 'T',
        beleg_ex: '',
        nkr_kasse: '',
        ausfuehr: '',
        anehmer: '',
        sendweg: 'EMAIL',
        email: '',
        fax: '',
        re_anrede: '',
        re_vorname: '',
        re_name_1: '',
        re_strh_nr: '',
        re_land: '',
        re_plz: '',
        re_ort: '',
        re_nr: '',
        kombi: '',
        kombi_1: '',
        budget: 0,
        use_mwst: false,
        mwst_percentage: 0,
      }
      this.auftragBackup = {};
      this.editMode = true;
    },
    checkErrors() {
      let hasError = false;
      this.auftrag.task = this.auftrag.task.trim();
      this.auftrag.object = this.auftrag.object.trim();
      if (this.auftrag.pos_nr !== '0000' && this.auftrag.task.length === 0) {
        this.errors.taskError = false;
        console.log("task error")
        hasError = true;
      }
      if (this.auftrag.object.length === 0) {
        this.errors.objectError = false;
        console.log("object error")
        hasError = true;
      }
      console.log(this.auftrag.legr);
      if (this.auftrag.pos_nr !== '0000' && this.auftrag.legr.length === 0) {
        this.errors.legrError = false;
        console.log("legr error")
        hasError = true;
      }
      if (this.settings.useAnehmer && this.auftrag.anehmer.length === 0) {
        this.errors.anehmerError = false;
        console.log("anehmer error")
        this.ageber = true;
        hasError = true;
      }
      if (this.settings.useKombi && this.auftrag.kombi.length === 0) {
        this.errors.kombiError = false;
        console.log("kombi error")
        this.ageber = true;
        hasError = true;
      }
      if (this.auftrag.hh_ein.length === 0) {
        this.errors.hhEinError = false;
        console.log("hhein error")
        hasError = true;
      }
      if (this.auftrag.hh_aus.length === 0) {
        this.errors.hhAusError = false;
        console.log("hhaus error")
        hasError = true;
      }
      if (this.settings.zwtKreislauf) {
        if (this.auftrag.hh_fahr.length === 0) {
          this.errors.hhFahrError = false;
          console.log("hhfahr error")
          hasError = true;
        }
        if (this.auftrag.hh_mat.length === 0) {
          this.errors.hhMatError = false;
          console.log("hhmat error")
          hasError = true;
        }
      }
      return hasError;
    },
    onSave() {
      // check for input fields
      if (this.checkErrors()) {
        console.log("found errors")
        return;
      }
      if (!this.auftrag.id && this.auftrag.pos_nr === '0000') {
        this.saveAuftrag(null);
        return;
      } else if (!this.auftrag.id) {
        // einzel -> show dialog
        this.$refs.accept_dialog.showDialog({}, false);
        return;
      }
      // first check if we have a change in hh
      if(this.auftrag.hh_aus !== this.auftragBackup.hh_aus
          || this.auftrag.hh_ein !== this.auftragBackup.hh_ein
          || this.auftrag.hh_fahr !== this.auftragBackup.hh_fahr
          || this.auftrag.hh_mat !== this.auftragBackup.hh_mat) {
        this.$refs.check_hh_date_dialog.showModal();
        return;
      }
      this.saveAuftrag(null);
    },
    async saveEinzel({close_automatic, selected_kost, ziel_datum, todos}) {
      this.showLoader();
      for (let i = 0; i < this.commune_select.length; i++) {
        if (this.commune_select[i].name === this.auftrag.kombi) {
          this.auftrag.kombi = this.commune_select[i].bis_id;
        }
      }
      if (this.auftrag.aar === '') {
        this.auftrag.aar = 'A';
      }
      for (let i = 0; i < this.aar_select.length; i++) {
        if (this.aar_select[i].value === this.auftrag.aar) {
          this.auftrag.zaar_text = this.aar_select[i].text;
        }
      }
      this.auftrag.mwst_percentage = parseFloat(this.auftrag.mwst_percentage);
      this.auftrag.use_mwst = this.auftrag.mwst_percentage !== 0;
      this.auftrag.budget = parseFloat(this.auftrag.budget);
      let payload = await encryptTask(sessionStorage.getItem("aes"), this.auftrag)
      todos = await encryptTodos(sessionStorage.getItem("aes"), todos)
      this.$http.post(
          Server_URL+'/auftragsbuch/data/stamm', {
            auftrag: payload,
            key: sessionStorage.getItem("aes"),
            is_einzel: true,
            selected_kost: selected_kost,
            ziel_datum: ziel_datum,
            close_automatically: close_automatic,
            todos: todos,
            address: this.address,
          }
      ).then(this.responseOkUpsertAuftrag, this.responseError)
    },
    async saveAuftrag(hhDate) {
      this.showLoader();
      for (let i = 0; i < this.commune_select.length; i++) {
        if (this.commune_select[i].name === this.auftrag.kombi) {
          this.auftrag.kombi = this.commune_select[i].bis_id;
        }
      }
      if (this.auftrag.aar === '') {
        this.auftrag.aar = 'A';
      }
      for (let i = 0; i < this.aar_select.length; i++) {
        if (this.aar_select[i].value === this.auftrag.aar) {
          this.auftrag.zaar_text = this.aar_select[i].text;
        }
      }
      if (hhDate) {
        this.auftrag.hh_change_date = hhDate;
      }
      this.auftrag.mwst_percentage = parseFloat(this.auftrag.mwst_percentage);
      this.auftrag.use_mwst = this.auftrag.mwst_percentage !== 0;
      this.auftrag.budget = parseFloat(this.auftrag.budget);
      let payload = await encryptTask(sessionStorage.getItem("aes"), this.auftrag)
      this.$http.post(
          Server_URL+'/auftragsbuch/data/stamm', {
            auftrag: payload,
            key: sessionStorage.getItem("aes"),
            address: this.address,
          }
      ).then(this.responseOkUpsertAuftrag, this.responseError)
    },
    createKKonto(k_konto) {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/k_konto', k_konto
      ).then(this.responseOkCreateKKonto, this.responseError)
    },
    setKKonto(k_konto) {
      console.log(k_konto)
      this.auftrag.hh_ein = k_konto.konto;
      this.auftrag.hh_ein_text = k_konto.konto_txt;
    },
    showKKontoSelect(e) {
      if (!this.editMode) {
        return
      }
      this.errors.hhEinError = null;
      this.$refs.select_k_konto_dialog.showDialog();
    },
    showCommuneSelect(e) {
      if (!this.editMode) {
        return
      }
      this.errors.kombiError = null;
      this.$refs.select_commune_dialog.showDialog();
    },
    async createCommune(commune) {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/commune', commune
      ).then(this.responseOkCreateCommune, this.responseError)
    },
    setCommune(commune) {
      this.auftrag.kombi = commune.name;
    },
    showSachSelect(e) {
      if (!this.editMode) {
        return
      }
      this.$refs.select_sach_dialog.showDialog();
    },
    async createSach(sach) {
      this.showLoader();
      let enc = await encryptSach(sessionStorage.getItem("aes"), sach);
      this.$http.post(
          Server_URL+'/auftragsbuch/data/sach', enc
      ).then(this.responseOkCreateSach, this.responseError)
    },
    setSach(sach) {
      this.auftrag.clerk = sach.name;
      this.auftrag.clerk_tel = sach.phone;
    },
    showAufnSelect(e) {
      if (!this.editMode) {
        return
      }
      this.errors.anehmerError = null;
      this.$refs.select_aufn_dialog.showDialog();
    },
    setBillingType(billingType) {
      this.auftrag.art_auf = billingType;
    },
    createAufn(aufn) {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/aufn', aufn
      ).then(this.responseOkCreateAufn, this.responseError)
    },
    setAufn(aufn) {
        this.auftrag.anehmer = aufn.name;
    },
    createKost(kost) {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/kost', kost
      ).then(this.responseOkCreateKost, this.responseError)
    },
    setKost(kost) {
      if (this.currentHhType === 'E') {
        this.auftrag.hh_ein_text = kost.name;
        this.auftrag.hh_ein = kost.name;
      } else {
        this.auftrag.hh_aus_text = kost.name;
        this.auftrag.hh_aus = kost.name;
      }
    },
    createHh(hh) {
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/hh', hh
      ).then(this.responseOkCreateHh, this.responseError)
    },
    setHh(hh) {
      if (!this.settings.zwtKreislauf) {
        if (this.currentHhType === 'E') {
          this.auftrag.hh_ein_text = hh.name;
          this.auftrag.hh_ein = hh.account;
        } else {
          this.auftrag.hh_aus_text = hh.name;
          this.auftrag.hh_aus = hh.account;
        }
      } else {
        if (this.currentHhType === 'E') {
          this.auftrag.hh_fahr_text = hh.name;
          this.auftrag.hh_fahr = hh.account;
        } else {
          this.auftrag.hh_mat_text = hh.name;
          this.auftrag.hh_mat = hh.account;
        }
      }
    },
    async createAddress(address) {
      address.name = address.first_name;
      let enc = await encryptAddress(sessionStorage.getItem("aes"), address);
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/address', enc
      ).then(this.responseOkCreateAddress, this.responseError)
    },
    setAddress(selected) {
      if (this.isDebitor) {
        this.auftrag.hh_aus_text = selected.first_name;
        this.auftrag.hh_aus = selected.debitor;
      } else {
        if (this.ageber) {
          this.auftrag.address_id = selected.bis_id;
          this.auftrag.salutation = selected.salutation;
          this.auftrag.name_1 = selected.first_name;
          this.auftrag.name_2 = selected.name_1;
          this.auftrag.street = selected.street + " " + selected.street_number;
          this.auftrag.street.trim();
          this.auftrag.zip_code = selected.zip_code;
          this.auftrag.city = selected.city;
          this.auftrag.fax = selected.fax;
          this.auftrag.email = selected.email;
        } else {
          this.auftrag.re_anrede = selected.salutation;
          this.auftrag.re_nr = selected.debitor;
          this.auftrag.re_vorname = selected.first_name;
          this.auftrag.re_name_1 = selected.name_1;
          this.auftrag.re_strh_nr = selected.street + " " + selected.street_number;
          this.auftrag.re_strh_nr.trim();
          this.auftrag.re_land = selected.country;
          this.auftrag.re_plz = selected.zip_code;
          this.auftrag.re_ort = selected.city;
        }
      }
      setTimeout(() => {
        this.isDebitor = false;
      }, 200)
    },
    goToGps() {
      this.$router.push("/geo_referencing/reference?aufisn="+this.auftrag.aufisn);
    },
    showBillingType(e) {
      if (!this.editMode) {
        return
      }
      this.$refs.billing_type_dialog.showDialog();
    },
    showSelectHh(hhType) {
      if (!this.editMode) {
        return
      }
      switch (hhType) {
        case 'E':
          if (this.settings.zwtKreislauf) {
            this.errors.hhFahrError = null;
          } else {
            this.errors.hhEinError = null;
          }
          break;
        case 'A':
          if(this.settings.zwtKreislauf) {
            this.errors.hhMatError = null;
          } else {
            this.errors.hhAusError = null;
          }
          break;
      }
      this.currentHhType = hhType;
      if (this.zwtKreislauf || this.currentAugr.augr_type !== 'KOST') {
        this.$refs.select_hh_dialog.showDialog();
      } else {
        this.$refs.select_kost_dialog.showDialog();
      }
    },
    onNodeSelect(node) {
      if (node.data.gischl) {
        this.selectedAugr = node.data.gischl;
        this.currentAugr = node.data;
      } else {
        this.selectedAugr = '';
      }
      if (this.currentSelection && this.currentSelection.key === node.key || node.data.gischl) {
        return;
      }
      this.currentSelection = node;
      if (this.$route.query.key !== node.key) {
        this.$router.replace({
          path: this.$route.path,
          query: {key: this.currentSelection.key}
        })
      }
      this.showLoader();
      this.$http.get(
          Server_URL+'/auftragsbuch/data/stamm/'+this.currentSelection.key
      ).then(this.responseOkGetAuftrag, this.responseError)
    },
    onNodeUnselect(node) {
      this.selectedAugr = '';
    },
    onSaveSettings(set) {
      this.settings.showClosed = set.showClosed;
      this.settings.showLegr = set.showLegr;
      this.settings.zwtKreislauf = set.zwtKreislauf;
      this.settings.useAnehmer = set.useAnehmer;
      this.settings.anehmerName = set.anehmerName;
      this.settings.useKombi = set.useKombi;
      this.settings.kombiName = set.kombiName;
      this.settings.maskKonto = set.maskKonto;
      this.settings.descKonto = set.descKonto;
      this.settings.mwsts = set.mwsts;
      let payload = [
        {id: 'ae_show_closed_show_leist', value_1: this.settings.showClosed ? 'true' : 'false', value_2: this.settings.showLegr ? 'true' : 'false'},
        {id: 'ae_split_expenditure', value_1: this.settings.zwtKreislauf ? 'true' : 'false'},
        {id: 'ae_aufn', value_1: this.settings.useAnehmer ? 'true' : 'false', value_2: this.settings.anehmerName},
        {id: 'ae_kombi', value_1: this.settings.useKombi ? 'true' : 'false', value_2: this.settings.kombiName},
        {id: 'ae_konto_mask', value_1: this.settings.maskKonto, value_2: this.settings.descKonto},
      ]
      payload = payload.concat(this.settings.mwsts);
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/ae_setting', payload
      ).then(this.responseOkTrap, this.responseError)
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    async responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        console.log(response)
        this.nodes = response.body.tree;
        this.nodes = this.nodes.sort((a, b) => {
          return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        })
        this.legrs = response.body.legrs;
        this.augrTypesAvailable = response.body.augr_types;
        this.commune_select = response.body.communes;
        console.log(this.commune_select)
        this.commune_select.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        console.log(this.commune_select)
        this.kosts = response.body.kosts;
        this.kosts.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        this.anehmer = response.body.districts;
        this.anehmer.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        this.hhs = response.body.hhs;
        this.hhs.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        this.legrs.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        for (let i = 0; i < this.hhs.length; i++) {
          let hh = this.hhs[i];
          hh.text = hh.name + " | " + hh.account;
          if (hh.in_out === "E") {
            this.hhEin.push(hh)
          } else if (hh.in_out === "A") {
            this.hhAus.push(hh);
          } else {
            this.hhEin.push(hh);
            this.hhAus.push(hh)
          }
        }
        this.addresses = await decryptAddress(sessionStorage.getItem("aes"), response.body.address);
        this.addresses.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        for (let i = 0; i < this.addresses.length; i++) {
          this.addresses[i].text = this.addresses[i].name + " | " + this.addresses[i].debitor
        }

        this.k_konten = response.body.k_konten;
        for (let i = 0; i < this.k_konten.length; i++) {
          this.k_konten[i].text = this.k_konten[i].konto_txt + " | " + this.k_konten[i].konto
        }

        this.sachs = await decryptSach(sessionStorage.getItem("aes"), response.body.sachs);
        this.sachs.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        for (let i = 0; i < this.sachs.length; i++) {
          this.sachs[i].text = this.sachs[i].name + "\t" + this.sachs[i].phone
        }
        this.augrs = response.body.augrs;
        this.augrs.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
        this.parseSettings(response.body.settings)
        if (this.$route.query.key) {
          setTimeout(() => {
            this.selectedKey[this.$route.query.key] = true;
            this.findKey(this.nodes);
            if(this.$route.query.edit === 'true') {
              this.editMode = true;
            }
          });
        }
        this.bauhofStructure = response.body.bauhof_structure;
        this.av_close_defaults = response.body.av_close_defaults;
      } else {
        window.location = Redirect_500;
      }
    },
    parseSettings(settings) {
      this.settings.showClosed = settings['ae_show_closed_show_leist'].value_1 === 'true';
      this.settings.showLegr = settings['ae_show_closed_show_leist'].value_2 === 'true';
      this.settings.zwtKreislauf = settings['ae_split_expenditure'].value_1 === 'true';
      this.settings.useAnehmer = settings['ae_aufn'].value_1 === 'true';
      this.settings.anehmerName = settings['ae_aufn'].value_2;
      this.settings.useKombi = settings['ae_kombi'].value_1 === 'true';
      this.settings.kombiName = settings['ae_kombi'].value_2;
      this.settings.maskKonto = settings['ae_konto_mask'].value_1;
      this.settings.descKonto = settings['ae_konto_mask'].value_2;
      this.settings.mwsts.push(settings['ae_mwst_7']);
      this.settings.mwsts.push(settings['ae_mwst_19']);
      this.settings.mwsts.push(settings['ae_mwst_10']);
      this.settings.mwsts.push(settings['ae_mwst_13']);
      this.settings.mwsts.push(settings['ae_mwst_20']);
      this.settings.mwsts.push(settings['ae_mwst_x1']);
      this.settings.mwsts.push(settings['ae_mwst_x2']);
    },
    findKey(searchData) {
      for (let i = 0; i < searchData.length; i++) {
        if (searchData[i].key === this.$route.query.key) {
          this.onNodeSelect(searchData[i]);
          return true
        } else if (searchData[i].children && searchData[i].children.length) {
          if (this.findKey(searchData[i].children)) {
            this.expandedKeys[searchData[i].key] = true;
            console.log(this.expandedKeys);
            return true
          }
        }
      }
      return false;
    },
    toggleEdit() {
      if (this.editMode) {
        if (this.auftrag.aufisn === 'wird vergeben') {
          this.auftrag = null;
        } else {
          this.auftrag = {...this.auftragBackup};
          this.formateGpsAddress();
        }
      }
      this.editMode = !this.editMode;
    },
    async responseOkGetAuftrag(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        this.expandedKeys = {...this.expandedKeys};
        console.log(this.expandedKeys);
        this.auftrag = await decryptTask(sessionStorage.getItem("aes"), response.body.auftrag);
        this.auftragBackup = {...this.auftrag};
        this.selectedAugr = this.auftrag.augr;
        for (let i = 0; i < this.augrs.length; i++) {
          if (this.augrs[i].gischl === this.selectedAugr) {
            this.currentAugr = this.augrs[i];
          }
        }
        this.auftragAugrName = response.body.augr_name;
        this.gpsAddress = response.body.gps;
        this.gpsAddress.strasse_hnr = this.gpsAddress.strasse_hnr.trim();
        this.gpsAddress.land = this.gpsAddress.land.trim();
        this.gpsAddress.plz = this.gpsAddress.plz.trim();
        this.gpsAddress.ort = this.gpsAddress.ort.trim();
        this.formateGpsAddress();
        for (let i = 0; i < this.anehmer.length; i++) {
          if (this.anehmer[i].bis_id === this.auftrag.anhemer) {
            this.auftrag.anehmer = this.anehmer[i].name;
          }
        }
        for (let i = 0; i < this.commune_select.length; i++) {
          if (this.commune_select[i].bis_id === this.auftrag.kombi) {
            this.auftrag.kombi = this.commune_select[i].name;
          }
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkUpsertAuftrag(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        console.log(response.body)
        let node = response.body;
        let augrNode = null;
        for (let i = 0; i < this.nodes.length; i++) {
          if (this.nodes[i].key === this.currentAugr.id) {
            augrNode = this.nodes[i];
          }
        }
        if (augrNode === null) {
          console.log("did not find correct augr")
          // fallback
          this.$router.replace({
            path: this.$route.path,
            query: {key: response.body.key}
          })
          this.$router.go();
          return
        }
        let changed = false;
        // find the correct entry; two possibilities: either in this level if pos_nr === '0000'|'9999' Or one level deeper
        if (node.data.pos_nr === '0000' || node.data.pos_nr === '9999') {
          let found = false;
          for (let i = 0; i < augrNode.children.length; i++) {
            if (augrNode.children[i].key === node.key) {
              augrNode.children[i].label = node.label;
              augrNode.children[i].data = node.data;
              found = true;
              changed = true;
              break;
            }
          }
          if (!found) {
            augrNode.children.push(node)
          }
          augrNode.children.sort((a, b) => {
            return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
          })
        } else {
          let stammNode = null;
          for (let i = 0; i < augrNode.children.length; i++) {
            if (augrNode.children[i].data.aufisn === node.data.aufisn) {
              stammNode = augrNode.children[i];
              break
            }
          }
          if (stammNode === null) {
            // fallback
            this.$router.replace({
              path: this.$route.path,
              query: {key: response.body.key}
            })
            this.$router.go();
            return
          }

          let found = false;
          for (let i = 0; i < stammNode.children.length; i++) {
            if (stammNode.children[i].key === node.key) {
              stammNode.children[i] = node;
              found = true;
              changed = true;
              break;
            }
          }
          if (!found) {
            stammNode.children.push(node)
          }
          stammNode.children.sort((a, b) => {
            return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
          })
        }
        if (!changed) {
          this.$router.replace({
            path: this.$route.path,
            query: {key: node.key}
          })
          setTimeout(() => {
            this.selectedKey = {};
            this.selectedKey[node.key] = true;
            let res = this.findKey(this.nodes);
            this.editMode = false;
          });
        } else {
          this.$router.replace({
            path: this.$route.path,
            query: {key: node.key}
          })
          setTimeout(() => {
            this.selectedKey = {};
            this.selectedKey[node.key] = true;
            let res = this.findKey(this.nodes);
            this.editMode = false;
            this.expandedKeys = {...this.expandedKeys};
            this.auftragBackup = {...this.auftrag};
          });
        }
      } else {
        window.location = Redirect_500;
      }
    },
    formateGpsAddress() {
      this.address = '';
      if (this.gpsAddress.id !== '') {
        this.address = this.gpsAddress.strasse_hnr;
        if (this.gpsAddress.strasse_hnr && (this.gpsAddress.land || this.gpsAddress.plz || this.gpsAddress.ort)) {
          this.address += ", ";
        }
        if (this.gpsAddress.land) {
          this.address += this.gpsAddress.land;
          if (this.gpsAddress.plz) {
            this.address += "-" + this.gpsAddress.plz;
          }
          this.address += " " + this.gpsAddress.ort;
        } else if (this.gpsAddress.plz) {
          this.address += this.gpsAddress.plz + " " + this.gpsAddress.ort;
        } else {
          this.address += this.gpsAddress.ort;
        }
        this.address = this.address.trim();
      }
    },
    responseOkCreateAugr(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        console.log(response.body)
        this.nodes.push(response.body);
        this.nodes.sort((a, b) => {
          return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        })
        this.augrs.push(response.body.data);
        this.augrs.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        })
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {

      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkCreateAddress(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let add = await decryptAddress(sessionStorage.getItem("aes"), [response.body]);
        this.addresses.push(add[0]);
        this.setAddress(add[0])
      } else {
        window.location = Redirect_500;
      }
      this.isDebitor = false;
    },
    responseOkCreateHh(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let hh = response.body;
        this.hhs.push(hh);
        hh.text = hh.name + " | " + hh.account;
        if (hh.in_out === "E") {
          this.hhEin.push(hh)
        } else if (hh.in_out === "A") {
          this.hhAus.push(hh);
        } else {
          this.hhEin.push(hh);
          this.hhAus.push(hh)
        }
        if (this.currentHhType === hh.in_out || hh.in_out === 'X') {
          this.setHh(hh);
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkCreateKost(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let kost = response.body;
        this.kosts.push(kost);
        this.setKost(kost);
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkCreateAufn(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let aufn = response.body;
        this.anehmer.push(aufn);
        this.auftrag.anehmer = aufn.name;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkCreateKKonto(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let k_konto = response.body;
        k_konto.text = k_konto.konto_txt + " | " + k_konto.konto;

        this.k_konten.push(k_konto);
        this.auftrag.hh_ein = k_konto.konto;
        this.auftrag.hh_ein_text = k_konto.konto_txt;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkCreateCommune(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let commune = response.body;
        this.commune_select.push(commune);
        this.auftrag.kombi = commune.name;
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkCreateSach(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        let add = await decryptSach(sessionStorage.getItem("aes"), [response.body]);
        add[0].text = add[0].name + "\t" + add[0].phone
        this.sachs.push(add[0]);
        this.setSach(add[0])
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    onCreateAugr({augr, augr_type}) {
      console.log(augr, augr_type)
      if (augr_type === "FAHR") {
        this.augrTypesAvailable.fahr = false;
      } else if (augr_type === "PLAY") {
        this.augrTypesAvailable.play = false;
      } else if (augr_type === "STREET") {
        this.augrTypesAvailable.street = false;
      }
      this.showLoader();
      this.$http.post(
          Server_URL+'/auftragsbuch/data/augr', {
            augr: augr,
            augr_type: augr_type
          }
      ).then(this.responseOkCreateAugr, this.responseError)
    },
  },
  computed: {
    currentOptions() {
      if (!this.currentRightClickNode) {
        console.log("menu cleard")
        return [];
      } else {
        let res = [];
        let node = this.currentRightClickNode;
        if (node.data.augr_type !== undefined) {
          // we are at augr level
          res.push("Umbenennen");
          if (!node.children || !node.children.length) {
            res.push("Löschen");
          }
        } else if (node.data.aufisn && node.data.pos_nr === '0000') {
          res.push("Auftragsgruppe wechseln");
          if (node.can_delete && !node.data.is_closed) {
            res.push("Löschen");
          } else if (!node.data.is_closed) {
            res.push("Sperren");
          }
        }
        console.log(res)
        return res;
      }
    },
    mwst_select() {
      let res = [{value: 0, text: '---'}];
      for (let i = 0; i < this.settings.mwsts.length; i++) {
        if (this.settings.mwsts[i].value_2 === 'true') {
          res.push({value: parseInt(this.settings.mwsts[i].value_1), text: this.settings.mwsts[i].value_1+'%'});
        }
      }
      return res;
    },
    currentHhs() {
      return this.currentHhType === 'E' ? this.hhEin : this.hhAus;
    },
    augrNames() {
      let res = [];
      for (let node of this.nodes) {
        res.push(node.label)
      }
      return res;
    },
    filteredNodes() {
      if (this.settings.showLegr && this.settings.showClosed) {
        return this.nodes;
      }
      let res = [];
      for (let i = 0; i < this.nodes.length; i++) {
        let augr = {...this.nodes[i]};
        augr.children = [];
        res.push(augr);
        for (let j = 0; j < this.nodes[i].children.length; j++) {
          let stamm = {...this.nodes[i].children[j]};
          stamm.children = []
          if (!this.settings.showClosed && stamm.data.is_closed) {
            continue;
          }
          augr.children.push(stamm);
          for (let k = 0; k < this.nodes[i].children[j].children.length; k++) {
            let unter = {...this.nodes[i].children[j].children[k]};
            if ((this.settings.showClosed || !unter.data.is_closed) && (this.settings.showLegr || parseInt(unter.data.pos_nr) > 200)) {
              stamm.children.push(unter);
            }
          }
        }
      }
      return res;
    }
  }
}
</script>

<style scoped>
.hover:hover {
  transform: scale(1.1);
  opacity: .7;
  cursor: pointer;
}
</style>

<style>
.custom-icon > .material-design-icon__svg {
  bottom: 0 !important;
}

.custom-icon-size > .material-design-icon__svg {
  width: 1rem !important;
  height: 1rem !important;
  bottom: 0.3rem !important;
  left: 1rem;
}
.label-horizontal {
  display: inline-flex;
  align-items: center;
}
.label-fc-height {
  height: calc(1.5em + 0.75rem + 2px)
}
.fc-disabled {
  background-color: #eeffc5 !important;
}

.sel-enabled {
  background-color: white !important;
}
</style>
